/* import __COLOCATED_TEMPLATE__ from './freelancer-earnings-calculator.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';
import { closeModal } from "sh-www/utils/modal-controls";

/**
 * Model for freelancer-earnings-calculator modal
 * @typedef {Object} FreelancerEarningsCalculatorComponentModel
 * @property {Object} threadModel
 * @property {User} buyer
 * @property {User} seller
 * @property {boolean} isToggleView
 */

class FreelancerEarningsCalculatorComponent extends Component {
  tagName = '';

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default FreelancerEarningsCalculatorComponent;
